import React from 'react';
import { Col } from 'Common/components/Atoms/Flex';
import { useTheme } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
}

export function Footer({ children }: Props): JSX.Element {
  const theme = useTheme();
  return (
    <Col
      mt={4}
      justifyContent="center"
      borderTop={`solid 1px ${theme.palette.grey[300]}`}
      py={1}
    >
      {children}
    </Col>
  );
}
